/* eslint-disable camelcase */
import i18next from 'i18next';

i18next.addResources('es_CL', 'AddressInput', {
  enterAddress: 'Ingresa tu dirección...',
  whereDoYouWantToOrderToday: '¿Dónde quieres pedir hoy?'
});
